import React, { Component } from 'react'

class Blogs extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render(){

    return (
        
           
        <iframe title="Blogs" src="https://blog.polarisinvesting.com" frameborder="0" width="930" height="500" scrolling="yes" allowfullscreen></iframe>

    )
  }
}

export default Blogs



// WEBPACK FOOTER //
// ./src/components/Blogs.js